import React from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { Link, useParams } from 'react-router-dom';

import {
  BodyWrapper,
  Header,
  Loader,
  MainWrapper,
  WelcomeElement,
} from '@components';
import { businessQuery, datamodelsQuery } from '@queries';

import { ProjectBreadcrumbs } from '../components/ProjectBreadcrumbs/ProjectBreadcrumbs.jsx';
import ProjectSidebar from '../components/ProjectSidebar/ProjectSidebar.jsx';

import { DataModel } from './DataModel/DataModel.jsx';

const DataModels = () => {
  const { t, i18n } = useTranslation();
  const { businessID } = useParams();

  // get business
  const { data: businessData, isPending: businessIsPending } = useQuery(
    businessQuery(businessID),
  );

  // get datamodels
  const {
    data: datamodelsData,
    isPending: datamodelsIsPending,
    isError,
  } = useQuery(
    datamodelsQuery({
      order_by: 'datamodel_type',
    }),
  );

  return (
    <>
      <Header />
      <BodyWrapper>
        <ProjectSidebar businessID={businessID} businessData={businessData} />
        <MainWrapper>
          <ProjectBreadcrumbs businessData={businessData}>
            <li className="sb-flex">
              <span>{t('Manage fields')}</span>
            </li>
          </ProjectBreadcrumbs>
          <div className="sb-manage-content">
            <div className="sb-manage-content-head">
              <h1>{t('Manage fields')}</h1>
              <div className="sb-button-list-inline">
                <Link
                  to={`/dashboard/projects/${businessID}/datamodels/new`}
                  className="sb-btn sb-btn-cancel"
                >
                  Add new
                </Link>
              </div>
            </div>
            {datamodelsIsPending && (
              <Loader className="sb-loader sb-loader-large" />
            )}
            {!datamodelsIsPending &&
              (isError || datamodelsData.objects?.length === 0) && (
                <WelcomeElement>
                  <h1>Welcome to manage fields</h1>
                  <p>
                    Fields can be used for easy customization of the content you
                    manage across Websites, Locations and Pages in your Project
                  </p>
                  <Link
                    to={`/dashboard/projects/${businessID}/datamodels/new`}
                    className="sb-btn sb-btn-save"
                  >
                    Start adding fields
                  </Link>
                </WelcomeElement>
              )}
            {!datamodelsIsPending && (
              <div className="sb-content-view-row">
                {datamodelsData.objects.map((datamodel) => {
                  return (
                    <DataModel
                      key={datamodel.id}
                      businessID={businessID}
                      datamodel={datamodel}
                    />
                  );
                })}
              </div>
            )}
          </div>
        </MainWrapper>
      </BodyWrapper>
    </>
  );
};

export default DataModels;
